import React, { useCallback, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { getCall, postCall } from "../../services/apiCall";
import { getPayloadHash } from "../../services/helper";
import { useInfoProvider } from "../../context/InfoContext";

const Navbar = () => {
  const location = useLocation();
  const path = location.pathname.substring(1);
  const [isOpen, setIsOpen] = useState(false);
  const [activeLink, setActiveLink] = useState("home");
  const { setInfo } = useInfoProvider();

  const handleLinkClick = (link) => {
    setActiveLink(link);
    setIsOpen(false);
  };

  useEffect(() => {
    console.log("path", path);
    handleLinkClick(path || "home");
  }, [path]);

  // *********************** User Info Api Calling *****************************

  const getInfo = useCallback(async () => {
    const payload = {};
    let dataToSend = { data: getPayloadHash({ data: payload }) };
    try {
      const response = await postCall("/app_details", dataToSend);
      if (response?.status_code === 200) {
        setInfo(response?.JOBS_APP);
        // console.log("response", response?.JOBS_APP);
      }
      console.log("response", response);
    } catch (error) {
      console.log("error", error);
    }
  }, []);

  useEffect(() => {
    getInfo();
  }, []);

  return (
    <nav className="bg-white sticky top-0 z-50 shadow-sm border-b border-gray-100 backdrop-blur-sm bg-opacity-90">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo with Slogan */}
          <div className="flex-shrink-0 flex items-center space-x-3">
            <Link to="/" className="flex items-center group">
              <img
                src="/logo.png"
                className="h-12 md:h-14 transition-all duration-300 group-hover:scale-105"
                alt="GIGSAM Logo"
              />
              <div className="ml-3 hidden sm:block">
                <h1 className="text-xl font-bold text-gray-900">GIGSAM</h1>
                {/* <p className="text-xs font-medium text-gray-500 mt-[-2px]">
                  Connecting Talent with Opportunity
                </p> */}
              </div>
            </Link>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:block">
            <div className="ml-10 flex items-center space-x-6">
              <Link
                to="/"
                className={`relative px-3 py-2 text-sm font-medium transition-all duration-300 ${
                  activeLink === "home"
                    ? "text-blue-600 font-semibold"
                    : "text-gray-700 hover:text-blue-500"
                }`}
                onClick={() => handleLinkClick("home")}
              >
                Home
                {activeLink === "home" && (
                  <span className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-6 h-1 bg-blue-600 rounded-full"></span>
                )}
              </Link>

              <Link
                to="/about"
                className={`relative px-3 py-2 text-sm font-medium transition-all duration-300 ${
                  activeLink === "about"
                    ? "text-blue-600 font-semibold"
                    : "text-gray-700 hover:text-blue-500"
                }`}
                onClick={() => handleLinkClick("about")}
              >
                About
                {activeLink === "about" && (
                  <span className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-6 h-1 bg-blue-600 rounded-full"></span>
                )}
              </Link>

              <Link
                to="/service"
                className={`relative px-3 py-2 text-sm font-medium transition-all duration-300 ${
                  activeLink === "service"
                    ? "text-blue-600 font-semibold"
                    : "text-gray-700 hover:text-blue-500"
                }`}
                onClick={() => handleLinkClick("service")}
              >
                Services
                {activeLink === "service" && (
                  <span className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-6 h-1 bg-blue-600 rounded-full"></span>
                )}
              </Link>

              <Link
                to="/contact"
                className={`relative px-3 py-2 text-sm font-medium transition-all duration-300 ${
                  activeLink === "contact"
                    ? "text-blue-600 font-semibold"
                    : "text-gray-700 hover:text-blue-500"
                }`}
                onClick={() => handleLinkClick("contact")}
              >
                Contact
                {activeLink === "contact" && (
                  <span className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-6 h-1 bg-blue-600 rounded-full"></span>
                )}
              </Link>

              {/* <div className="relative group ml-2">
                <Link
                  to="#"
                  className="px-6 py-2.5 bg-gradient-to-r from-blue-600 to-blue-500 text-white font-medium rounded-full shadow-md hover:shadow-lg transition-all duration-300 transform hover:scale-[1.03] flex items-center"
                >
                  Apply Now
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-4 w-4 ml-1 transition-transform duration-300 group-hover:translate-x-1"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M14 5l7 7m0 0l-7 7m7-7H3"
                    />
                  </svg>
                </Link>
                <div className="absolute -bottom-1 left-0 right-0 h-1 bg-blue-400 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </div> */}
            </div>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden flex items-center space-x-3">
            {/* <Link
              to="#"
              className="px-4 py-2 bg-gradient-to-r from-blue-600 to-blue-500 text-white text-sm font-medium rounded-full shadow-md hover:shadow-lg transition-transform hover:scale-105"
            >
              Apply
            </Link> */}
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="inline-flex items-center justify-center p-2 rounded-md text-gray-700 hover:text-blue-600 hover:bg-gray-100 focus:outline-none transition-all duration-200"
              aria-expanded="false"
            >
              <span className="sr-only">Open main menu</span>
              {!isOpen ? (
                <svg
                  className="block h-6 w-6"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                </svg>
              ) : (
                <svg
                  className="block h-6 w-6"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              )}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Navigation */}
      <div
        className={`md:hidden transition-all duration-300 ease-in-out overflow-hidden ${
          isOpen ? "max-h-96 shadow-lg" : "max-h-0"
        }`}
      >
        <div className="px-2 pt-2 pb-4 space-y-2 sm:px-3 bg-white">
          <Link
            to="/"
            className={`block px-4 py-3 rounded-lg text-base font-medium transition-all ${
              activeLink === "home"
                ? "bg-blue-50 text-blue-600 font-semibold"
                : "text-gray-700 hover:bg-gray-50 hover:text-blue-600"
            }`}
            onClick={() => {
              handleLinkClick("home");
              setIsOpen(false);
            }}
          >
            Home
          </Link>

          <Link
            to="/about"
            className={`block px-4 py-3 rounded-lg text-base font-medium transition-all ${
              activeLink === "about"
                ? "bg-blue-50 text-blue-600 font-semibold"
                : "text-gray-700 hover:bg-gray-50 hover:text-blue-600"
            }`}
            onClick={() => {
              handleLinkClick("about");
              setIsOpen(false);
            }}
          >
            About
          </Link>

          <Link
            to="/service"
            className={`block px-4 py-3 rounded-lg text-base font-medium transition-all ${
              activeLink === "service"
                ? "bg-blue-50 text-blue-600 font-semibold"
                : "text-gray-700 hover:bg-gray-50 hover:text-blue-600"
            }`}
            onClick={() => {
              handleLinkClick("service");
              setIsOpen(false);
            }}
          >
            Services
          </Link>

          <Link
            to="/contact"
            className={`block px-4 py-3 rounded-lg text-base font-medium transition-all ${
              activeLink === "contact"
                ? "bg-blue-50 text-blue-600 font-semibold"
                : "text-gray-700 hover:bg-gray-50 hover:text-blue-600"
            }`}
            onClick={() => {
              handleLinkClick("contact");
              setIsOpen(false);
            }}
          >
            Contact
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
